// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__AtrJF","icon":"styles_icon__NZKpQ","text":"styles_text__uOhDI"};